import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Register from "@/pages/Register";
import PassView from "@/pages/PassView";
import Login from "@/pages/Login";
import AdminLayout from "@/components/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import LiveVisitors from "@/pages/admin/LiveVisitors";
import VisitorLog from "@/pages/admin/VisitorLog";
import VisitorProfile from "@/pages/admin/VisitorProfile";
import Leads from "@/pages/admin/Leads";
import Conversions from "@/pages/admin/Conversions";
import Followups from "@/pages/admin/Followups";
import Analytics from "@/pages/admin/Analytics";
import Walking from "@/pages/admin/Walking";
import Campaigns from "@/pages/admin/Campaigns";
import Team from "@/pages/admin/Team";
import Reports from "@/pages/admin/Reports";
import Settings from "@/pages/admin/Settings";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/register" element={<Register />} />
      <Route path="/pass/:visitorId" element={<PassView />} />
      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="live" element={<LiveVisitors />} />
        <Route path="visitors" element={<VisitorLog />} />
        <Route path="visitors/:visitorId" element={<VisitorProfile />} />
        <Route path="leads" element={<Leads />} />
        <Route path="conversions" element={<Conversions />} />
        <Route path="followups" element={<Followups />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="walking" element={<Walking />} />
        <Route path="campaigns" element={<Campaigns />} />
        <Route path="team" element={<Team />} />
        <Route path="reports" element={<Reports />} />
        <Route path="settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
